import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    color: "#3f3f3f",
    backgroundColor: "white",
    borderRadius: 5,
    fontSize: 14,
    padding: 8,
  },
  inputMultiline: {
    paddingTop: 8,
    paddingBottom: 8,
  },
  underline: {
    "&:after": {
      borderBottom: "3px solid #216174",
    },
  },
});

const QuestionTextInput = (props) => {
  const classes = useStyles();
  return (
    // <FormControl className={classes.questionInput}>
    <TextField
      InputProps={{ classes }}
      // className={classes.questionInputBase}
      fullWidth={props.fullWidth}
      label={props.label}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={props.value}
      type={props.type}
      helperText={props.helperText}
      onChange={props.onChange}
    />
    // </FormControl>
  );
};

export default QuestionTextInput;
